import { render } from "./caseShare.vue?vue&type=template&id=918f8d64"
import script from "./caseShare.vue?vue&type=script&lang=js"
export * from "./caseShare.vue?vue&type=script&lang=js"

import "./caseShare.vue?vue&type=style&index=0&id=918f8d64&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__